import { PencilLine } from "lucide-react"

import type { CustomerSource } from "../api/forecast_catalog_api"

interface CustomerSourceBadgeProps {
  source: CustomerSource
  netsuite_name?: string | null
  className?: string
}

/** Marks a customer as billed in NetSuite (actuals flow to it) or added by hand (plan only). */
export function CustomerSourceBadge({ source, netsuite_name, className = "" }: CustomerSourceBadgeProps) {
  if (source === "netsuite") {
    return (
      <span
        class={`inline-flex h-4 min-w-4 shrink-0 items-center justify-center rounded-sm bg-blue-700 px-0.5 text-[9px] font-bold leading-none tracking-tight text-white ${className}`}
        title={netsuite_name ? `NetSuite customer: ${netsuite_name}` : "NetSuite customer"}
        aria-label="NetSuite customer"
      >
        NS
      </span>
    )
  }
  return (
    <span
      class={`inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm bg-gray-200 text-gray-600 ${className}`}
      title="Custom customer: not in NetSuite, so it has no actuals of its own"
      aria-label="Custom customer"
    >
      <PencilLine className="h-2.5 w-2.5" />
    </span>
  )
}
